module.exports = __webpack_public_path__ + "static/media/TwistedFate.b9d51654.png";